import React, { type ComponentType } from 'react';
import { styled } from '@compiled/react';
import Heading from '@atlaskit/heading';
import { token } from '@atlaskit/tokens';
import type {
	IntlShapeV2 as IntlShape,
	MessageDescriptorV2 as MessageDescriptor,
} from '@atlassian/jira-intl/src/v2/types.tsx';

export type Props = {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Action: ComponentType<Record<any, any>>;
	title: MessageDescriptor;
	description: MessageDescriptor;
	imageUrl: string;
	intl: IntlShape;
};

function TypeSelector(props: Props) {
	const { Action, title, description, imageUrl } = props;
	const {
		intl: { formatMessage },
	} = props;
	return (
		<Container>
			<Image src={imageUrl} alt="" />
			<Description>
				<Heading size="small" as="h2">
					{formatMessage(title)}
				</Heading>
				{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
				<p>{formatMessage(description)}</p>
			</Description>
			<ToggleIconContainer>
				<Action />
			</ToggleIconContainer>
		</Container>
	);
}

export default TypeSelector;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	display: 'flex',
	alignItems: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Image = styled.img({
	width: '100px',
	height: 'auto',
	marginRight: token('space.400'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Description = styled.div({
	flex: '1 1 auto',
	marginRight: token('space.400'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ToggleIconContainer = styled.div({
	flexShrink: 0,
});
